import script from "./ResourceList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceList.vue?vue&type=script&setup=true&lang=js"

import "./ResourceList.vue?vue&type=style&index=0&id=7407ee46&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7407ee46"]])

export default __exports__